import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { TextStyle } from '@website-builder/widgets/text/model/text-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class TextWidget extends BaseWidget<TextStyle> {
  readonly type = BuilderElementType.Text;
  style: TextStyle = new TextStyle();
  content =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.';

  static normalizeInPlace(widget: TextWidget): TextWidget {
    const pureWidget = new TextWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.content = widget.content ?? pureWidget.content;

    widget.style = TextStyle.normalize(widget.style);

    return widget;
  }
}
